// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-listing {
  padding-left: 1rem;
  list-style: disc;
}

.tip-amount {
  color: var(--tipAmountText) !important;
}

.chat-announcement-wrap {
  position: sticky;
  top: 0.313rem;
  z-index: 2;
}

.user-social-list-wrap {
  margin-top: 0.625rem;
}
.user-social-list-wrap a {
  height: 1.875rem;
  width: 1.875rem;
  border: 1px solid var(--profileCardBorder);
  margin: 0 5px;
  border-radius: 0.313rem;
}
.user-social-list-wrap a svg {
  width: 1rem;
  height: 1rem;
}

.chat-inner-header h4 {
  font-size: 0.875rem;
}
.chat-inner-header svg {
  margin-right: 0.313rem;
}
.chat-inner-header a {
  color: var(--authSocailTextColor);
  font-weight: 500;
  font-size: 0.75rem;
}
.chat-inner-header a svg {
  margin-right: 0;
}

.chat-badge-wrap .chat-badge-lising-wrap svg {
  height: 2.063rem;
  width: 2.063rem;
  margin-right: 0.313rem;
}

.profile-pic-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.profile-pic-wrapper .profile-pic {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.profile-pic-wrapper .image-upload-box {
  width: 100%;
  height: 180px;
  background-color: var(--cardBgBox);
  border-radius: 8px;
  border-width: 1px;
  border-style: dashed;
  border-color: var(--headerBtnHover);
}

.preview-wrap {
  padding: 16px;
  background-color: var(--sidebarTooltip);
  border-radius: 8px;
  width: 100%;
}
.preview-wrap .preview-heading {
  background-color: var(--dragtextBg);
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
}
.preview-wrap .slider-wrap {
  font-size: 1.25rem;
}
.preview-wrap .form-range::-webkit-slider-runnable-track {
  height: 0.25rem;
  background-color: var(--cardBgBox);
}
.preview-wrap .form-range::-webkit-slider-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background-color: var(--white);
  margin-top: -0.5rem;
}
.preview-wrap .react-transform-wrapper .react-transform-component {
  height: 160px;
  width: 160px;
}
.preview-wrap .preview-circle-wrap {
  position: absolute;
  margin: auto;
  height: 160px;
  width: 160px;
  overflow: hidden;
}
.preview-wrap .preview-circle {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  box-shadow: 0 0 2000px 2000px var(--previewBg);
  z-index: 1;
  width: 124px;
  height: 124px;
  border-radius: 50%;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/components/Chat/chat.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,UAAA;AACF;;AAEA;EACE,oBAAA;AACF;AACE;EACE,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;AACN;;AAKE;EACE,mBAAA;AAFJ;AAKE;EACE,sBAAA;AAHJ;AAME;EACE,iCAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,eAAA;AAJN;;AAWI;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;AARN;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAVF;AAYE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAVJ;AAgBE;EACE,WAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mCAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;AAfF;AAiBE;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAfJ;AAkBE;EACE,kBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,kCAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,cAAA;EACA,8BAAA;EACA,mBAAA;AAlBJ;AA2BI;EACE,aAAA;EACA,YAAA;AAzBN;AA6BE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,8CAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AA5BJ","sourcesContent":[".tooltip-listing {\n  padding-left: 1rem;\n  list-style: disc;\n}\n\n.tip-amount {\n  color: var(--tipAmountText) !important;\n}\n\n.chat-announcement-wrap {\n  position: sticky;\n  top: 0.313rem;\n  z-index: 2;\n}\n\n.user-social-list-wrap {\n  margin-top: 0.625rem;\n\n  a {\n    height: 1.875rem;\n    width: 1.875rem;\n    border: 1px solid var(--profileCardBorder);\n    margin: 0 5px;\n    border-radius: 0.313rem;\n\n    svg {\n      width: 1rem;\n      height: 1rem;\n    }\n  }\n}\n\n.chat-inner-header {\n  h4 {\n    font-size: 0.875rem;\n  }\n\n  svg {\n    margin-right: 0.313rem;\n  }\n\n  a {\n    color: var(--authSocailTextColor);\n    font-weight: 500;\n    font-size: 0.75rem;\n\n    svg {\n      margin-right: 0;\n    }\n  }\n}\n\n.chat-badge-wrap {\n  .chat-badge-lising-wrap {\n    svg {\n      height: 2.063rem;\n      width: 2.063rem;\n      margin-right: 0.313rem;\n    }\n  }\n}\n\n.profile-pic-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .profile-pic {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    // border: solid 1px black;\n    // margin-bottom: 12px;\n    // margin-top: 10px;\n  }\n\n  .image-upload-box {\n    width: 100%;\n    height: 180px;\n    background-color: var(--cardBgBox);\n    border-radius: 8px;\n    border-width: 1px;\n    border-style: dashed;\n    border-color: var(--headerBtnHover);\n  }\n}\n\n.preview-wrap {\n  padding: 16px;\n  background-color: var(--sidebarTooltip);\n  border-radius: 8px;\n  width: 100%;\n\n  .preview-heading {\n    background-color: var(--dragtextBg);\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-weight: 500;\n    font-size: 14px;\n    margin: 0;\n  }\n\n  .slider-wrap {\n    font-size: 1.25rem;\n  }\n\n  .form-range::-webkit-slider-runnable-track {\n    height: 0.25rem;\n    background-color: var(--cardBgBox);\n  }\n\n  .form-range::-webkit-slider-thumb {\n    height: 1.25rem;\n    width: 1.25rem;\n    background-color: var(--white);\n    margin-top: -0.5rem;\n  }\n\n  .react-transform-wrapper {\n    // background-color: red;\n    // padding: 10px;\n    // height: 160px;\n    // width: 160px;\n\n    .react-transform-component {\n      height: 160px;\n      width: 160px;\n    }\n  }\n\n  .preview-circle-wrap {\n    position: absolute;\n    margin: auto;\n    height: 160px;\n    width: 160px;\n    overflow: hidden;\n  }\n\n  .preview-circle {\n    position: absolute;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    box-shadow: 0 0 2000px 2000px var(--previewBg);\n    z-index: 1;\n    width: 124px;\n    height: 124px;\n    border-radius: 50%;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
